import React, { useState } from 'react';
import { Box, Typography, TextField, Button, Alert, Paper, Fade, useTheme } from '@mui/material';
import { Business, LockOutlined, PersonOutline } from '@mui/icons-material';
import { DeviceUUID } from 'device-uuid/lib/device-uuid';
import { useLocation, useNavigate } from 'react-router-dom';
import logo from 'images/magikevolution_logo.png';
import { useAuth } from 'hooks/use-auth';

export function LoginPage() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const [company, setCompany] = useState('');
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  const deviceId = new DeviceUUID().get();
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();
  const auth = useAuth();

  const isFormValid = company.length && username.length && password.length ? true : false;
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      let from = location.state?.from;
      if (!from || from === '/login') {
        from = '/products/products';
      }
      await auth.login(company, deviceId, username, password);
      navigate(from, { replace: true });
    } catch (err) {
      setError('Credenciais inválidas. Por favor, tente novamente.');
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        backgroundColor: 'background.default',
        p: 2,
      }}
    >
      <Fade in timeout={500}>
        <Paper
          elevation={3}
          sx={{
            width: '100%',
            maxWidth: 450,
            p: 4,
            borderRadius: 2,
            boxShadow: theme.shadows[6],
            backgroundColor: 'background.paper',
          }}
        >
          <Box sx={{ textAlign: 'center', mb: 3 }}>
            <img src={logo} alt="App Logo" style={{ width: '64px', height: 'auto', marginBottom: '4px' }} />
            <Typography variant="h5" component="h1" sx={{ fontWeight: 600 }}>
              Cloudsales WMS
            </Typography>
          </Box>

          {error && (
            <Alert severity="error" sx={{ mb: 3 }}>
              {error}
            </Alert>
          )}

          <Box component="form" onSubmit={handleSubmit} noValidate>
            <TextField
              fullWidth
              margin="normal"
              label="Empresa"
              value={company}
              onChange={(e) => setCompany(e.target.value)}
              required
              InputProps={{
                startAdornment: (
                  <Business
                    sx={{
                      mr: 1,
                      color: theme.palette.mode === 'dark' ? 'text.secondary' : 'action.active',
                    }}
                  />
                ),
              }}
              sx={{ mb: 2 }}
            />

            <TextField
              fullWidth
              margin="normal"
              label="Utilizador"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              InputProps={{
                startAdornment: (
                  <PersonOutline
                    sx={{
                      mr: 1,
                      color: theme.palette.mode === 'dark' ? 'text.secondary' : 'action.active',
                    }}
                  />
                ),
              }}
              sx={{ mb: 2 }}
            />

            <TextField
              fullWidth
              margin="normal"
              label="Palavra-passe"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              InputProps={{
                startAdornment: (
                  <LockOutlined
                    sx={{
                      mr: 1,
                      color: theme.palette.mode === 'dark' ? 'text.secondary' : 'action.active',
                    }}
                  />
                ),
              }}
              sx={{ mb: 4 }}
            />

            <Button
              fullWidth
              type="submit"
              variant="contained"
              size="large"
              disabled={!isFormValid || loading}
              sx={{
                py: 1.5,
                borderRadius: 1,
                fontSize: 16,
              }}
            >
              {loading ? 'A entrar...' : 'Login'}
            </Button>
          </Box>
        </Paper>
      </Fade>
    </Box>
  );
}
